import { ComponentInstall } from "../../utils";
import ProcedureProgress from "./src";
import Procedure from "./src/Procedure";

export default ComponentInstall(ProcedureProgress, Procedure);
